.marker {
  color: var(--bs-primary);
  cursor: pointer;

  & > svg {
    /* filter: drop-shadow(rgba(0, 0, 0, 0.5) 0 0 3px); */
    filter: drop-shadow(0 0 1px rgba(0, 0, 0, 0.5));
    transition: font-size 0.1s;
  }

  /* &>div {
    opacity: 0;
    animation: fadeIn 0.35s ease forwards;
    transition: transform 0.35s;

    &:hover {
      opacity: 1;
      transform: scale(1.5);
    }
  }

  &:nth-child(4n)>div {
    animation-delay: 0.15s
  }

  &:nth-child(4n+1)>div {
    animation-delay: 0s;
  }

  &:nth-child(4n+2)>div {
    animation-delay: 0.05s;
  }

  &:nth-child(4n+3)>div {
    animation-delay: 0.1s;
  } */
}

.resetButton {
  /* position: absolute;
  top: 60px;
  left: 10px;
  width: 29px;
  height: 29px;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  transition: background-color 0.2s;

  &:hover {
    background-color: #f0f0f0;
  }

  &:active {
    background-color: #e0e0e0;
  } */
}

/* 
@keyframes fadeIn {
  to {
    opacity: 0.9;
  }
} */
